/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigDeleteRequest extends models.ServiceNowCmdbConfigBaseRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigDeleteRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigDeleteRequest>): ServiceNowCmdbConfigDeleteRequest {
        let obj = Object.assign(new ServiceNowCmdbConfigDeleteRequest(), model);
        ServiceNowCmdbConfigDeleteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigDeleteRequest>): ServiceNowCmdbConfigDeleteRequest {
        if (!model) return null;
        return ServiceNowCmdbConfigDeleteRequest.newInstance(<ServiceNowCmdbConfigDeleteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigDeleteRequest) {
        if (!obj) return;

        models.ServiceNowCmdbConfigDeleteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigDeleteRequest): boolean {
        if (models.ServiceNowCmdbConfigBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigDeleteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
